import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input, Select } from '../../../../components/ModalInputs'
import CustomSelect from '../../../../components/CustomSelect'
import { OrderContext } from '../../../../utils/context'
import { arrayForSelect } from '../../../../utils/arrayForSelect'
import moment from 'moment'
import { getCourses } from '../../../../actions/common'
import Counter from '../../../../components/Counter'
import MoneyInput from '../../../../components/MoneyInput/MoneyInput'

const ARR = [
  { value: 1, name: '2' },
  { value: 2, name: '3' },
  { value: 3, name: '4' },
  { value: 4, name: '5' },
  { value: 5, name: '6' },
  { value: 6, name: '7' },
  { value: 7, name: '8' },
  { value: 8, name: '9' },
  { value: 9, name: '10' },
  { value: 10, name: '11' },
  { value: 11, name: '12' },

]

export default function ReceptionOfEmployees() {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, error, specFields } = useContext(OrderContext)

  const { courses } = useSelector(state => state.common)
  const [moneyRub, setMoneyRub] = useState(values.money)

  useEffect(() => {
    dispatch(getCourses())
  }, [])

  useEffect(() => {
    values.money && setMoneyRub(`${values.money} руб.`)
  }, [values.money])


  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              options={arrayForSelect(personnelList, 'fio', 'mid')}
              value={values.mid}
              // value={values.mid}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
              error={error('mid')}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='На должность'
              name='string'
              value={values.string}
              error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>

            <MoneyInput // деньги в рублях с копеями money:10000 => 100.00
              title='Оклад'
              value={values.money}
              setFieldValue={setFieldValue}
              name='money'
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              error={error('date')}
              type='date'
              label='Дата с'
              name='date'
              value={values.date || moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
            <Input
              error={error('date2')}
              type='date'
              label='по'
              name='date2'
              value={values.date2 || moment(values.date2).format('YYYY-MM-DD')}
              onChange={handleChange}
            />

          </div>
          <div className={styles.inputsRow}>
            <Checkbox
              name='logical'
              label='На неопределенный срок'
              checked={values.logical}
              onChange={() => setFieldValue('logical', Number(!values.logical))}
            />
          </div>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='Отдельная дисциплина'
              valuesName="num"
              options={arrayForSelect(courses, 'title', 'cid')}
              value={values.num}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
            />
          </div>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='Учебный курс (номер параллели)'
              valuesName="num2"
              options={ARR}
              value={values.num2}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
            />
          </div>
          <div className={styles.inputsRow}>
            <Counter
              label='Стаж работы, дающий право на получение % надбавки за выслугу лет'
              type='number'
              name='num3'
              value={values && values.num3}
              setFieldValue={setFieldValue}
              onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Испытательный срок'
              type='number'
              step='0.1'
              name='string2'
              value={values.string2}
              error={error('string2')}
              onChange={e => setFieldValue('string2', e.target.value)}
              onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Counter
              label='Учебная нагрузка, час.'
              type='number'
              name='num4'
              value={values && values.num4}
              setFieldValue={setFieldValue}
            />
          </div>
          <div className={styles.inputsRow}>
            <Checkbox
              name='logical2'
              label='Совместительство'
              checked={values.logical2}
              onChange={() => setFieldValue('logical2', Number(!values.logical2))}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Ставка'
              type='number'
              step='0.1'
              name='string3'
              value={values.string3}
              error={error('string3')}
              onChange={e => setFieldValue('string3', e.target.value)}
              style={{ width: '300px' }}
              onKeyPress={e => !/[0-9]/.test(e.key) && e.preventDefault()}
            />
          </div>

        </div>
      </div >

    </>
  )
}
